 import React, { useState, useEffect } from 'react';
import Breadcrumb from '../Components/Breadcrumb';
import Pagehelmet from '../Components/Pagehelmet';
 
import axios from 'axios';
import { useLocation } from 'react-router-dom';
import { useParams, useNavigate } from 'react-router-dom';
const MyOrders = () => {
  const navigate = useNavigate();
       const location = useLocation();
         const { order } = location.state || {};

         const {

_id,
             user,
    event,
    tickets,
  
    totalAmount,
    discount,
    status,
    paymentMethod,
    paymentId,
    billingAddress,
    createdAt,
    updatedAt,
         } = order
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loading, setLoading] = useState(false);
  const [editMode, setEditMode] = useState(false);
 
  const [profileData, setProfileData] = useState({
    address: "",
    email: "",
    emergencyContact: "",
    familyMembers: "",
    firstName: "",
    lastName: "",
    phone: "",
    preferences: "",
    role: ""
  });

 
  // ... keep all your existing functions (handleChange, handleSubmit, handleLogout)

  if (loading) {
    return (
      <div className="container text-center py-5">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  return (
    <div>
      <Pagehelmet pageTitle="My Orders" />
      <Breadcrumb title="My Orders" />

      <section className="profile-section py-5">
        <div className="container">
          <div className="row">
            {/* Left column with profile info (keep existing) */}
            <div className="col-lg-4 mb-4">
              {/* ... your existing profile card ... */}
            </div>

            {/* Right column with forms and orders */}
            <div className="col-lg-8">
              <div className="card p-4 mb-4">
                {/* ... your existing profile form ... */}
              </div>

              {/* New Orders Section */}
              <div className="card p-4">
                <h3 className="mb-4">My Orders</h3>
                
              
                  
            <div className="table-responsive">
  <table className="table">
     
    <table className="table">
  <tbody>
    <tr>
      <th>Order ID</th>
      <td>{_id}</td>
    </tr>
    <tr>
      <th>User</th>
      <td>{user?.firstName } {user?.lastName}</td>
    </tr>
    <tr>
      <th>Event</th>
      <td>{event?.name}</td>
    </tr>
    <tr>
      <th>Total Amount</th>
      <td>{totalAmount} ETB</td>
    </tr>
    {/* <tr>
      <th>Discount</th>
      <td>{discount} ETB</td>
    </tr> */}
    <tr>
      <th>Payment Method</th>
      <td>{paymentMethod}</td>
    </tr>
    <tr>
      <th>Payment ID</th>
      <td>{paymentId || 'N/A'}</td>
    </tr>
    <tr>
      <th>Billing Address</th>
      <td>{billingAddress || 'N/A'}</td>
    </tr>
    <tr>
      <th>Status</th>
      <td>
        <span className={`badge ${
          status === 'completed' ? 'bg-success' :
          status === 'pending' ? 'bg-warning' :
          'bg-secondary'
        }`}>
          {status}
        </span>
      </td>
    </tr>
    <tr>
      <th>Created At</th>
      <td>{new Date(createdAt).toLocaleDateString()}</td>
    </tr>
    <tr>
      <th>Updated At</th>
      <td>{new Date(updatedAt).toLocaleDateString()}</td>
    </tr>
  </tbody>
</table>

  </table>
</div>

              
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default MyOrders;